export enum VisionDateFormatTypeValue {
  US = 'MM/DD/YYYY',
  EU = 'DD/MM/YYYY',
}
